import { Observable } from 'rxjs';

import { UserInfo } from './user-info.types';

/**
 * Should only be used internally for impersonation purposes.
 * For all other use cases, use BenutzerService
 */
export abstract class UserInfoService {
    /**
     * Should only be used internally for impersonation purposes.
     * For all other use cases, use BenutzerService
     */
    abstract readonly loggedInUser: Observable<UserInfo>;
}
